// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"e14c6b79","453":"abd36b29"}[chunkId] + ".chunk.js";
};